var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[(_vm.currentUserIsOwner)?_c('ConnectionsList',{attrs:{"connections":_vm.connections,"allLoaded":_vm.allLoaded},on:{"loadMoreConnections":_vm.loadMoreConnections}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }